import React from 'react'

export default function RenderNorma(ficha, el, data) {
    if (el.tipoinfracao === "1 - Estágio não obrigatório do curso de Terapia Ocupacional em quantitativo acima do permitido na Resolução COFFITO 452/2015") {
        return (
            <>
                Art. 6º da Resolução COFFITO 452/2015 e Art. 9º, inciso VII da
                Resolução COFFITO nº 425/2013 e Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "2- Estágio obrigatório de acadêmicos(as) do curso de Terapia Ocupacional com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)") {
        return (
            <>
                Artigos 1º e 2º da Resolução COFFITO 451/2015, art. 41, VI e Art. 9º,
                incisos II e VII da Resolução COFFITO nº 425/2013 (Código de Ética e Deontologia do Terapeuta
                Ocupacional) e Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "3- Exercício ilegal da profissão de terapeuta ocupacional.") {
        return (
            <>
                Artigo 12 e Artigo 16 incisos I e VIII da Lei 6.316/75;
                Artigos 2º e 3º do Decreto-Lei 938/69; Artigo. 47 do Decreto-Lei nº 3.688
                (Lei das Contravenções Penais)
            </>
        )
    }
    else if (el.tipoinfracao === "4- Prática de atividades da Terapia Ocupacional por pessoa não habilitada.") {
        return (
            <>
                Artigos 2º e 4º do Decreto-Lei 938/69 e art. 47 do
                Decreto-Lei nº 3.688 ( Lei das Contravenções Penais).
            </>
        )
    }
    else if (el.tipoinfracao === "5- Delegação de função privativa do profissional terapeuta ocupacional.") {
        return (
            <>
                Art. 4º da Resolução COFFITO 81/87, art. 9º, incisos II e VII e art. 25,
                I da Resolução COFFITO nº 425/2013 (Código de Ética e Deontologia da Terapia Ocupacional) e art.
                16, I, IV e VIII da Lei nº 6.316/1975
            </>
        )
    }
    else if (el.tipoinfracao === "6- Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.") {
        return (
            <>
                Art. 5º da Resolução COFFITO No 037/1984.
            </>
        )
    }
    else if (el.tipoinfracao === "7- Ausência do responsável técnico de Terapia Ocupacional.") {
        return (
            <>
                Art. 1º da Resolução COFFITO 139/1992, art. 31 e Art. 9º,
                inciso VII da Resolução COFFITO 425/13 (código de ética profissional de Terapia Ocupacional) e
                Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "8- Profissional com Licença Temporária de Terapia Ocupacional vencida.") {
        var dataLtf = `${el.vencimento.slice(8, 10)}/${el.vencimento.slice(5, 7)}/${el.vencimento.slice(0, 4)}`
        return (
            <>
                Art. 12, da Lei 6316/75, que dispõe sobre a obrigatoriedade do registro
                profissional junto ao CREFITO.
            </>
        )
    }
    else if (el.tipoinfracao === "9- Falta de registro das atividades assistenciais terapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo terapeuta ocupacional, da guarda e do seu descarte. (Responsável Técnico)") {
        return (
            <>
                O descumprimento das normas e leis vigentes no país, notadamente as
                Resoluções em questão, configura infração aos art. 2º incisos I e III e art. 3º da resolução
                COFFITO Nº 139/92), que dispõe sobre as atribuições do Exercício da Responsabilidade Técnica,
                arts. 1º e 2º da Resolução COFFITO 415/12 e art. 16, incisos I e VII da Lei 6.316/75 e Art. 9º,
                inciso VII da Resolução COFFITO nº 425/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "10- Falta de registro de consultório.") {
        return (
            <>
                Artigo 105 da Resolução COFFITO Nº08/1978.
            </>
        )
    }
    else if (el.tipoinfracao === "11- Débitos com obrigações pecuniárias.") {
        return (
            <>
                Art. 15 e Art. 16, incisos I e VII da Lei 6.316/75 e Art. 9º,
                inciso VII da Resolução COFFITO nº 425/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "12- Descumprimento dos parâmetros assistenciais terapêuticos.(Responsável Técnico).") {
        return (
            <>
                •	Artigo 2º, Incisos I e III e ao Artigo 3º da Resolução COFFITO Nº 139/92, que dispõe sobre as atribuições do Exercício da Responsabilidade Técnica.
                <br />•	Artigo 9º, Incisos VII e VIII da Resolução COFFITO 425/13 que trata do Código de Ética e Deontologia da Terapia Ocupacional.
                <br />•	Artigo 16º, Incisos I e VIII da Lei nº 6.316/1975.
                <br />•	Resolução COFFITO nº 445/13.
            </>
        )
    }
    else if (el.tipoinfracao === "13- Descumprimento da Portaria CREFITO-1 Nº 046/2020.") {
        return (
            <>
                Portaria CREFITO-1 Nº 046/2020 (Institui as diretrizes para o funcionamento dos
                serviços de Fisioterapia e de Terapia Ocupacional, na rede pública ou privada, visando evitar a
                proliferação do novo Coronavírus (Sars-CoV-2), causador da pandemia de Covid-19).
            </>
        )
    }
    else if (el.tipoinfracao === "14- Descumprimento da legislação referente ao registro em prontuário dos terapeutas ocupacionais.") {
        return (
            <>
                Artigos 1º e 2º da Resolução COFFITO 415/12, Artigo 16, incisos I e VII da Lei
                6.316/75 e Artigo 9º, inciso VII da Resolução COFFITO nº 425/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "15- Publicidade irregular - exposição de pacientes.") {
        return (
            <>
                Art. 15, inciso V da Resolução COFFITO Nº 425/13, Art. 9º, inciso VII do
                mesmo códex e Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "16- Publicidade irregular.") {
        return (
            <>
                Art. 9º, inciso VI e VII da Resolução COFFITO No 425/2013 e
                Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "17- Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.") {
        return (
            <>
                Art. 1º da Resolução COFFITO Nº 037/84, que dispõe sobre o Registro de
                empresas nos Conselhos Regionais de Fisioterapia e Terapia Ocupacional e Art. 12, parágrafo
                único, da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "18- Profissional sem registro de inscrição secundária.") {
        return (
            <>
                Art. 1º da resolução COFFITO Nº 433/2013 e Art. 16, VII da Lei Nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "19- Desvio de circunscrição, pois o terapeuta ocupacional não realizou a transferência.") {
        return (
            <>
                Arts. 84 a 86 da Resolução COFFITO Nº 08/1978 e Art. 16, VII, da Lei Nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "20- Falta de cadastro do estabelecimento fiscalizado de Terapia Ocupacional.") {
        return (
            <>
                Artigo 1º, inciso I, da Resolução COFFITO nº 37/1984.
            </>
        )
    }
}